import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { translations } from './translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'es';
    return window.localStorage.getItem('tair_lang') || 'es';
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('tair_lang', lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    toggle: () => setLang((prev) => (prev === 'es' ? 'en' : 'es')),
    t: translations[lang],
  }), [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
